import React from 'react';
import VideoTiles from './VideoTiles';

const FloatingVideoStrip = () => (
  <div
    style={{
      position: 'fixed',
      bottom: 12,
      right: 12,
      zIndex: 50,
      pointerEvents: 'none',
    }}
  >
    <VideoTiles
      style={{ pointerEvents: 'auto' }}
      tileStyle={{ width: 96, height: 72 }}
    />
  </div>
);

export default FloatingVideoStrip;
